import React, { useEffect, useState } from "react";
import { Box, Typography, Stack, Avatar } from "@mui/material";
import ApiService from "./../../services/api-service";
import LockIcon from "@mui/icons-material/Lock";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import Loader from "./../../components/Loader";
import NoData from "./../../components/Nodata";
import Back from "../../components/Back";
import { Images } from "../../assets/common";
import { useDispatch } from "react-redux";
import { addSongAction } from "./../../action/songs";
import {
  fullName,
  getUserId,
  HMS,
  isOwnerId,
} from "./../../constants/function";
import { useParams, useHistory } from "react-router-dom";

import PlaylistStaticsCard from "../../components/PlaylistStaticsCard";
import ProfileMenu from "../../components/ProfileMenu";
import OutsideClickHandler from "react-outside-click-handler";
import notifier from "../../components/Notifier";
import { useTranslation } from "react-i18next";
export default function PlaylistStatics() {
  const { t } = useTranslation("common");
  const history = useHistory();
  const userId = getUserId();
  const dispatch = useDispatch();
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const { playListId, createdBy } = useParams();
  const [loading, setLoading] = useState();
  const [data, setData] = useState({});
  useEffect(() => {
    if (playListId && createdBy) getPlaylistStatics(playListId, createdBy);
  }, []);

  /**
   * @param  {} playListId
   * @param  {} createdBy
   */
  const getPlaylistStatics = async (playListId, createdBy) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_STATICS({
        playlistid: playListId,
        playlistcreator: createdBy,
        _id: userId,
      });
      setData({ ...response["result"] });
      setLoading(false);
      //console.log(data);
    } catch (error) {
      setLoading(false);
    }
  };
  const toggleMenu = (value, id, index) => {
    setOpen(false);
    setSelectedIndex(index);

    if (value && id) makeAction(value, id, index);
    else if (value) makeAction(value);
  };

  const makeAction = (key, id, index) => {
    switch (key) {
      case "m1":
        data["topStreamed"][index]?.nftId
          ? history.push(`/app/SongDetail/${data["topStreamed"][index]?.nftId}`)
          : history.push(`/app/SongDetails/${id}`);
        break;
      case "m24":
        removeSongFromPlaylist(index, data["topStreamed"][index], id);
        break;

      case "m2":
        if (!isOwnerId(createdBy) && !data["isSubscribed"] && data["isPrivate"])
          notifier.error(t("notifier.error.toast5"));
        else
          dispatch(addSongAction(data["topStreamed"][index], playListId, true));
        break;
      default:
        break;
    }
  };
  const play = (index) => {
    if (!isOwnerId(createdBy) && !data["isSubscribed"] && data["isPrivate"])
      notifier.error(t("notifier.error.toast5"));
    else dispatch(addSongAction(data["topStreamed"][index], playListId, true));
  };

  const removeSongFromPlaylist = async (index, song, id) => {
    try {
      setLoading(true);
      const response = await ApiService.REMOVE_SONG_FROM_PLAYLIST({
        musicId: song["_id"],
        playlistId: playListId,
      });
      const temp = data;
      temp["topStreamed"].splice(index, 1);
      setData({ ...temp });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <Box sx={{ paddingBottom: "100px" }}>
      <Back />
      <Box sx={{ padding: "0 24px" }}>
        <Typography
          sx={{ margin: "0 0 20px !important" }}
          className="web_header"
        >
          {t("playlistStatics.title")}
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "31px" }}>
          <Stack gap="35px" className="_responsive_flex">
            {/* <PlaylistStaticsCard
              color="#2EB49A"
              value={data["views"]}
              title={t("playlistStatics.header1")}
              image={Images.show}
            /> */}

            <PlaylistStaticsCard
              color="#2C98DB"
              value={data["listens"]}
              title={t("analytics.card.card3")}
              image={Images.listen}
            />

            <PlaylistStaticsCard
              color="#F48706"
              value={data["firstTimeListensCount"]}
              title={t("playlistStatics.header3")}
              image={Images.play_white}
            />

            <PlaylistStaticsCard
              color="#684DD8"
              value={data["firstTimeListings"]}
              title={t("playlistStatics.header4")}
              image={Images.listen_first}
            />
          </Stack>
          <Stack gap="35px" className="_responsive_flex">
            <PlaylistStaticsCard
              // color="#262626"
              color="#090909"
              border={"1px solid #2E2E2E"}
              value={data["topPlaylistCount"]}
              title={t("playlistStatics.header5")}
              image={Images.top_playlist}
            />

            <PlaylistStaticsCard
              // color="#262626"
              color="#090909"
              border={"1px solid #2E2E2E"}
              isArray={true}
              value={
                data["topTenListeners"]
                  ? data["topTenListeners"].length > 10 // passing only 10 enteries if >10
                    ? data["topTenListeners"].slice(0, 9)
                    : data["topTenListeners"]
                  : []
              }
              title={t("playlistStatics.header6")}
              image={Images.music_play}
            />

            <PlaylistStaticsCard
              // color="#262626"
              color="#090909"
              border={"1px solid #2E2E2E"}
              isTip={true}
              // tip={data["tip"]}
              value={data["topTenTips"]}
              title={"Top 10 Tippers"}
              image={Images.handHolding}
            />
          </Stack>

          <Box sx={{ padding: "0 18px 160px 18px", position: "relative" }}>
            <Typography
              className="fs-17 fade-text80"
              sx={{ letterSpacing: "1.87px" }}
            >
              {t("playlistStatics.title2")}
            </Typography>

            {data["topStreamed"] && data["topStreamed"].length > 0 ? (
              <table className="mymusic_table">
                <thead>
                  <tr>
                    <th>{t("playlistStatics.th1")}</th>
                    <th>{t("playlistStatics.th2")}</th>
                    <th>{t("playlistStatics.th3")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data["topStreamed"] &&
                    data["topStreamed"].map((music, index) => (
                      <tr key={index} style={{ position: "relative" }}>
                        <td>
                          <Stack direction="row" spacing={2}>
                            <Stack className="__music_thumb _cp">
                              <Avatar
                                src={
                                  music["thumbnailImg"]["filePath"]
                                    ? music["thumbnailImg"]["filePath"]
                                    : Images.rectangle
                                }
                              />
                              <img
                                onClick={() => play(index)}
                                className="__play_hover"
                                src={Images.play}
                                alt="play"
                              />
                            </Stack>
                            <Stack direction="column" justifyContent="center">
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                              >
                                <Typography
                                  variant="body1"
                                  className="fs-16 capitalize"
                                >
                                  {music["title"] ? music["title"] : ""}
                                </Typography>
                                {music["private"] ? (
                                  <LockIcon
                                    sx={{
                                      width: "11px",
                                      height: "11px",
                                      padding: "2px",
                                      color: "#989898",
                                      backgroundColor: "#4E4E4E",
                                    }}
                                    className="__small_icon"
                                  />
                                ) : null}
                              </Stack>
                              <Stack
                                direction="row"
                                alignItems="center"
                                sx={{
                                  overflowX: "scroll",
                                  gap: "6px",
                                  width: "245px",
                                }}
                                className="scroll_display_musicCard"
                              >
                                {music.artistData ? (
                                  music.artistData.map((a, index) => (
                                    <Typography
                                      className="fs-14 fade-text-60"
                                      key={index}
                                      style={{ whiteSpace: "nowrap" }}
                                    >
                                      {a?.displayArtistName}
                                      {index == music.artistData.length - 1
                                        ? ""
                                        : ","}
                                    </Typography>
                                  ))
                                ) : (
                                  <Typography
                                    variant="body2"
                                    className="fs-14 fade-text"
                                  >
                                    {music["artist"] ? music["artist"] : ""}
                                  </Typography>
                                )}
                              </Stack>
                            </Stack>
                          </Stack>
                        </td>
                        <td className="text-center text-white fs-14">
                          {HMS(music["duration"])}
                        </td>
                        <td className="text-right">
                          <MoreVertIcon
                            className="_cp"
                            onClick={() => {
                              setSelectedIndex(index);
                              setOpen(!open);
                            }}
                            color="default"
                          />
                        </td>
                        {index === selectedIndex && open ? (
                          <OutsideClickHandler
                            onOutsideClick={() => setOpen(false)}
                          >
                            <ProfileMenu
                              right={"0px"}
                              isLast={
                                index === music.length - 1 ? "-90px" : "40px"
                              }
                              isMenu={open}
                              actions={[
                                { key: "m1", action: t("dropMenu.m1") },
                                { key: "m2", action: t("dropMenu.m2") },
                                isOwnerId(createdBy)
                                  ? {
                                      key: "m24",
                                      action: t("dropMenu.m24"),
                                    }
                                  : "",
                              ]}
                              handleProfileMenuChoice={(action) =>
                                toggleMenu(action, music._id, index)
                              }
                            />
                          </OutsideClickHandler>
                        ) : null}
                      </tr>
                    ))}
                </tbody>
              </table>
            ) : (
              <NoData lable={t("noData.noData")} />
            )}
          </Box>
        </Box>
        {loading ? <Loader /> : null}
      </Box>
    </Box>
  );
}
